module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"error":{"notFound":"Произошла ошибка при отправке."}}}')
  delete Component.options._Ctor
}
